import AuthService from "../login/auth.service";
import { pronetPagos,comprobantes} from "../../components/generico/utils/UrlAPI";
import axios from "axios";

class ComprobantesServices {
  async comprobantesPronet(pagina, canal) {
    var data = JSON.stringify({
        cedula: AuthService.getCISocio(),
        pagina:pagina,
        canal:canal 
    
    });

    var config = {
      method: "post",
      url: pronetPagos + "getTrxBySocio",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);
  }

  async descagarComprobante(titulo, nroOperacion, nroSocioTitular, cuenta, ticket) {
    var _url = comprobantes + "comprobantes/v2/pagos-servicios";
    var data = JSON.stringify({
      titulo: titulo,
      nroOperacion: nroOperacion,
      nroSocioTitular: nroSocioTitular,
      cuentaDebito: cuenta,
      ticket: ticket
    });

    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);
  
  }

  async descagarComprobantePagoQR(data) {
    var _url = comprobantes + "comprobantes/v2/pagos-qr";

    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);
  
  }

  async descagarComprobanteOperacionQR(data) {
    var _url = comprobantes + "comprobantes/v2/pagos-qr-v3";

    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);
  
  }
}
export default new ComprobantesServices();